import type { ReactNode } from 'react';
import { ChevronDown } from './Icons';

interface PublicFaqItemProps {
  id: string;
  question: string;
  children: ReactNode;
}

export function PublicFaqItem({ id, question, children }: PublicFaqItemProps) {
  return (
    <details className="public-faq-item brand-feature-card rounded-2xl border transition-[box-shadow,border-color] duration-200 motion-reduce:transition-none">
      <summary
        className="brand-focus-ring block w-full cursor-pointer list-none rounded-2xl px-5 py-5 text-left sm:px-7 sm:py-6"
        aria-controls={id}
      >
        <span className="flex w-full items-start justify-between gap-4 text-lg font-semibold leading-7 text-slate-100 sm:text-xl">
          <span className="min-w-0">{question}</span>
          <span className="brand-text-strong flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[rgb(var(--theme-primary)/0.1)]" aria-hidden="true">
            <ChevronDown className="public-faq-chevron h-4 w-4 transition-transform motion-reduce:transition-none" />
          </span>
        </span>
      </summary>
      <div id={id}>
        <div className="theme-faq-answer space-y-4 px-5 pb-5 leading-8 sm:px-7 sm:pb-7">
          {children}
        </div>
      </div>
    </details>
  );
}
